var map = {
	"./template.betgalaxy": 2051,
	"./template.betgalaxy.tsx": 2051,
	"./template.betprofessor": 1135,
	"./template.betprofessor.tsx": 1135,
	"./template.betroyale": 1136,
	"./template.betroyale.tsx": 1136,
	"./template.default": 658,
	"./template.default.tsx": 658,
	"./template.fiestabet": 1137,
	"./template.fiestabet.tsx": 1137,
	"./template.puntcity": 1138,
	"./template.puntcity.tsx": 1138,
	"./template.puntgenie": 1139,
	"./template.puntgenie.tsx": 1139,
	"./template.questbet": 1140,
	"./template.questbet.tsx": 1140,
	"./template.ts": 969,
	"./template.volcanobet": 1141,
	"./template.volcanobet.tsx": 1141,
	"./template.wellbet": 1142,
	"./template.wellbet.tsx": 1142
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2422;